import { useState, useEffect } from 'react';

const API_URL = "https://facach.coop.hn/api";

let cache = null; // cache en memoria para no hacer fetch múltiples veces

export function useSiteSettings() {
  const [settings, setSettings] = useState(cache || {});
  const [loading, setLoading]   = useState(!cache);

  useEffect(() => {
    if (cache) { setSettings(cache); setLoading(false); return; }
    const fetch_ = async () => {
      try {
        const res = await fetch(`${API_URL}/site-settings`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (json.ok) { cache = json.data; setSettings(json.data); }
      } catch (err) {
        console.error("Error cargando site settings:", err.message);
      } finally { setLoading(false); }
    };
    fetch_();
  }, []);

  return { settings, loading };
}